import { render } from "./unlock-account-numbers-modal.vue?vue&type=template&id=fb8c71e0"
import script from "./unlock-account-numbers-modal.vue?vue&type=script&lang=js"
export * from "./unlock-account-numbers-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__